export default __webpack_public_path__ + "04678817d5a842c4d5aa3257637379f7.png";